import React from 'react'
import styled from 'styled-components'

interface Props {
  notificationText?: number | string
}

export const ButtonNotification: React.FC<Props> = ({ notificationText }) => {
  if (!notificationText) {
    return null
  }

  return <NotificationWrapper>{notificationText}</NotificationWrapper>
}

const NotificationWrapper = styled.div`
  z-index: 1;
  top: -10px;
  right: -8px;
  color: #fff;
  display: flex;
  padding: 0 5px;
  min-width: 20px;
  font-size: 12px;
  font-weight: 500;
  min-height: 20px;
  position: absolute;
  border-radius: 20px;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.colors.comment};
`
